import PropTypes from "prop-types";
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	StyleSheet,
	View
} from "react-native";

import InputLabel from "./Layout/InputLabel";
import InputContainer from "./Layout/InputContainer";
import StyledButton from "ae-base/Base/StyledButton";

var styles = StyleSheet.create({
	call: {
		alignSelf: "flex-end",
		marginLeft: 10
	},
	container: {
		flexDirection: "row",
		alignSelf: "flex-end"
	}
});

export default function InputCall(props, context){
	var dispatch = context.dispatch;
	var localize = context.localize;
	var schema = props.schema;
	var data = "" + (props.data || props.defaultValue || "");

	var parts = data.split(":");

	var type = parts[0];
	var onPress = null;
	var onPressVoice = null;

	if(type === "workflow") {
		onPress = dispatch("activeworkflowaction:trigger:call", {
			actor: parts[1]
		});
		onPressVoice = dispatch("activeworkflowaction:trigger:call", {
			actor: parts[1],
			voiceOnly: true
		});
	} else {
		onPress = dispatch("calling:trigger:call", {
			who: parts[1]
		});
		onPressVoice = dispatch("calling:trigger:call", {
			who: parts[1],
			voiceOnly: true
		});
	}

	const isNewCalling = schema?.newCalling;

	var callTitle = isNewCalling ? localize("calling.confirmCall") : localize("workflow.videocall");
	var voicecall = localize("workflow.voicecall");

	return (
		<InputContainer>
			<InputLabel schema={schema} />
			<View style={styles.container}>
				{!isNewCalling && <StyledButton id={props.id} contrast style={styles.call} onPress={onPressVoice} title={voicecall} icon="phone" />}
				<StyledButton id={props.id} contrast style={styles.call} onPress={onPress} title={callTitle} icon="video" />
			</View>
		</InputContainer>
	);
}

InputCall.contextTypes = {
	dispatch: PropTypes.func,
	localize: PropTypes.func
};